export default {
  title: 'Layer',
  videoResource: 'Video',
  audioResource: 'Audio',
  addGroupWarning: 'Video, audio node can not group',
  addGroupWarning1: 'DragonBone, Particle node can not group',
  addGroupWarning2: 'Quick Layout node can not group',
  treeCopyNode: {
    copyNode: {
      name: 'Duplicate layer',
    },
    pasteNode: {
      name: 'Paste layers',
      warning: 'Unwind node',
    },
    delete: {
      name: 'Delete layer',
    },
    ungroup: {
      name: 'Ungroup',
    },
  },
  treePasteNode: {
    name: 'Paste layers',
    warning: 'Unwind node',
  },
  nodeLabelBar: {
    endEditNameError: 'There is a rename of the text node, please rename it',
  },
  actionBar: {
    lock: 'Lock',
    unlock: 'Unlock',
    hiddenNode: 'Hide',
    showNode: 'Show',
  },
  video: 'Video',
  deleteConfirmTitle: 'Delete Elements/Scenes',
  deleteConfirmContent:
    'After deletion, it may cause the playable ad to fail to play normally. Are you sure to delete?',
  deleteConfirmCancel: 'Cancel',
  deleteConfirmConfirm: 'Delete',
  layerColor: 'Layer Color',
  noColor: 'No Color',
  red: 'Red',
  yellow: 'Yellow',
  green: 'Green',
  blue: 'Blue',
  purple: 'Purple',
}
